export const UPLOADING_STATUS = "uploading";
export const PENDING_STATUS = "pending";
export const ERROR_STATUS = "error";
export const SUCCESS_STATUS = "success";
export const GLOBAL_MESSAGE_STATUS = {
  INFO: "info",
  ERROR: "error",
  SUCCESS: "success",
};
